
import IntentsApi from './IntentsApi';
import EntitiesApi from './EntitiesApi';
import BuildApi from './BuildApi';
import TranscriptionsApi from './TranscriptionsApi';
import BotsApi from './BotsApi';
import FlowsApi from './FlowsApi';

import 'reflect-metadata';
import StatisticApi from './StatisticApi';
import { env } from '../../helpers/env';
import CustomerApi from './CustomerApi';
import MonitoringGraphApi from './MonitoringGraphApi';
import AnalyticsApi from './AnalyticsApi';

const HEADER = {};
const BASE_URL = env("REACT_APP_API_URL");

const AUTH_METADATA_KEY = 'Auth';
function isAuth(): PropertyDecorator {
  return (target, key) => {
    const authApi = Reflect.getOwnMetadata(AUTH_METADATA_KEY, target) || [];
    if (!authApi.includes(key)) {
      authApi.push(key);
    }
    Reflect.defineMetadata(AUTH_METADATA_KEY, authApi, target);
  };
}

class ApiManager {
    @isAuth()
    public intents: IntentsApi;

    @isAuth()
    public entities: EntitiesApi;

    @isAuth()
    public build: BuildApi;

    @isAuth()
    public transcriptions: TranscriptionsApi;

    @isAuth()
    public statistic: StatisticApi;

    @isAuth()
    public bots: BotsApi;

    @isAuth()
    public flows: FlowsApi;

    @isAuth()
    public customers: CustomerApi;

    @isAuth()
    public monitoringGraph: MonitoringGraphApi;

    @isAuth()
    public analytics: AnalyticsApi;

    constructor() {
      this.intents = new IntentsApi(BASE_URL, HEADER);
      this.entities = new EntitiesApi(BASE_URL, HEADER);
      this.build = new BuildApi(BASE_URL, HEADER);
      this.transcriptions = new TranscriptionsApi(BASE_URL, HEADER);
      this.statistic = new StatisticApi(BASE_URL, HEADER);
      this.bots = new BotsApi(BASE_URL, HEADER);
      this.flows = new FlowsApi(BASE_URL, HEADER);
      this.customers = new CustomerApi(BASE_URL, HEADER);
      this.monitoringGraph = new MonitoringGraphApi(BASE_URL, HEADER);
      this.analytics = new AnalyticsApi(BASE_URL, HEADER);
    }

    setBearer(bearer: string) {
      this.call('setBearer', bearer);
    }

    private call(fnName: string, ...parameters: any[]) {
      for (const api of Reflect.getOwnMetadata(AUTH_METADATA_KEY, ApiManager.prototype)) {
        (this as { [key: string]: any })[api][fnName](...parameters);
      }
    }
}

export default new ApiManager();
